import { defineComponent as c, computed as l, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as f, createCommentVNode as h, normalizeStyle as n, createStaticVNode as p } from "vue";
const _ = ["viewBox"], v = /* @__PURE__ */ t("mask", { id: "606d1da1-39e9-418e-a8be-3bfd8d4ff5ff" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#606d1da1-39e9-418e-a8be-3bfd8d4ff5ff)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#eee" d="m0 0 192 256L0 512h47l465-189v-34l-32-33 32-33v-34L47 0Z"></path><path fill="#333" d="M0 142v228l140-114z"></path><path fill="#ffda44" d="M192 256 0 95v47l114 114L0 370v47z"></path><path fill="#6da544" d="M512 223H223L0 0v94l161 162L0 418v94l223-223h289z"></path><path fill="#d80027" d="M512 0H47l189 189h276z"></path><path fill="#0052b4" d="M512 512H47l189-189h276z"></path>', 6), g = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ c({
  __name: "za",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(d) {
    const e = d, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (z, w) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      v,
      t("g", m, [
        e.flagName ? (s(), i("title", k, f(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  N as default
};
//# sourceMappingURL=za-338afb4c.js.map
